// @flow
import React from 'react';

import Modal from 'app/common/components/Modal';
import Button, { ButtonsBar } from 'app/common/ui/Button';
import Loading from 'app/common/components/Loader';

import enhanceRemoveProfile from './enhanceRemoveProfile';
import styles from './RemoveProfile.scss';


type Props = {
  close: (e: SyntheticEvent<HTMLElement>) => void,
  handleRemove: (e: SyntheticEvent<HTMLElement>) => void,
  text: string,
  buttons: [string, string],
  loading: boolean,
}

const RemoveProfile = ({
  close,
  handleRemove,
  text,
  buttons,
  loading,
}: Props) => (
  <Modal close={close} className={styles.content}>
    {loading
      ? <Loading className={styles.loading} />
      : <div className={styles.text}>{text}</div>}
    {!loading
      && <ButtonsBar middle>
        {buttons[0] && <Button value={buttons[0]} onClick={close} />}
        {buttons[1] && <Button value={buttons[1]} onClick={handleRemove} error />}
      </ButtonsBar>}
  </Modal>
);

export default enhanceRemoveProfile(RemoveProfile);
